import React from "react";

const ChipWithRef = React.forwardRef(({ label, icon, ...props }, ref) => {
  return (
    <button
      className="ChipWithRef flex items-center justify-center w-fit bg-primary text-white text-xs py-1 px-4 gap-2 rounded-full cursor-pointer hover:opacity-80 transition duration-200"
      ref={ref}
      {...props}
    >
      {label}
      {icon}
    </button>
  );
});

export default ChipWithRef;
